import { AxiosInstance, AxiosRequestConfig, AxiosStatic } from 'axios'
import { ApiRoutesNames } from 'bets.oddprovider.lib.common.ts/api/routes'
import { IParticipant } from 'bets.oddprovider.lib.common.ts/models'
import { IApiClientResult } from 'fwork-jsts-common/src/apiClient'
import { BaseApiClient } from 'fwork-jsts-common/src/apiClient'
import { FilterQuery } from 'mongoose'
import { store } from '../redux/store'

export class ParticipantsApiClient extends BaseApiClient<IParticipant, any, FilterQuery<IParticipant>, IParticipant, IParticipant> {
  constructor(axios: AxiosStatic | AxiosInstance) {
    const dotEnvProductionState = store.getState().dotEnvProductionState
    const baseUrl = `${dotEnvProductionState.payload?.APIURL}${ApiRoutesNames.participants}`
    super({
      apiUrl: baseUrl,
      axios,
    })
  }

  post(args: { data: IParticipant; status?: number[] | undefined; config?: AxiosRequestConfig<IParticipant> | undefined }): Promise<IApiClientResult<IParticipant>> {
    return super.post(args)
  }
}